import { render, staticRenderFns } from "./ServiceForm.vue?vue&type=template&id=08e3247a&scoped=true&"
import script from "./ServiceForm.vue?vue&type=script&lang=js&"
export * from "./ServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceForm.vue?vue&type=style&index=0&id=08e3247a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e3247a",
  null
  
)

export default component.exports